/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import { Fade } from 'react-awesome-reveal';
import { motion } from 'framer-motion';
import {
  FiUserCheck, FiTrendingUp, FiUsers, FiFileText, FiBarChart2, FiClipboard, FiCheckCircle, FiZap, 
} from 'react-icons/fi';

const companyServices = [
  { icon: FiUserCheck, title: 'Pre-Screened Professional Access', description: 'Multi-layer verification, independence assessment, credential revalidation.' },
  { icon: FiTrendingUp, title: 'Cost-Effective Recruitment', description: 'Reduced costs, AI-powered matching, transparent pricing.' },
  { icon: FiUsers, title: 'Women Director Access', description: 'Dedicated pool, mentorship, SEBI LODR diversity support.' },
  { icon: FiBarChart2, title: 'Compensation Benchmarking', description: 'Market intelligence, industry-specific data, compliance with regulatory limits.' },
  { icon: FiFileText, title: 'Documentation Support', description: 'Certification templates, evaluation frameworks, letters of appointment.' },
  { icon: FiClipboard, title: 'IPO/DRHP Support', description: 'Board composition analysis, profile validation, practicing company secretary support.' },
  { icon: FiBarChart2, title: 'Board Assessments', description: 'Structured evaluation, performance metrics, benchmarking with industry peers.' },
];

// Accordion Item for Independent Directors
function AccordionItem({ title, items }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="bg-white rounded-xl shadow-md mb-4 border-l-4 border-theme-purple hover:shadow-lg transition-all duration-300">
      <div
        className="flex justify-between items-center cursor-pointer p-5"
        onClick={() => setOpen(!open)}
      >
        <h4 className="text-lg font-semibold text-theme-blue">{title}</h4>
        <span className={`text-theme-blue font-bold transition-transform duration-300 ${open ? 'rotate-45' : ''}`}>+</span>
      </div>

      {/* Smooth collapse */}
      <div
        className="overflow-hidden transition-all duration-500 ease-in-out"
        style={{ maxHeight: open ? `${items.length * 2.5}rem` : '0' }}
      >
        <ul className="list-disc list-inside mt-2 ml-5 text-gray-600 text-sm space-y-1 pb-4 leading-relaxed">
          {items.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default function CharterContent() {
  const independentDirectorSections = [
    {
      title: '1. Onboarding Support',
      items: [
        'Digital Signature Certificate (Class 3 DSC) application guidance',
        'Director Identification Number (DIN) end-to-end support',
        'Independent Directors Databank (IDDB) registration and proficiency test preparation',
      ],
    },
    {
      title: '2. Board Access & Networking',
      items: [
        'Curated board opportunities across industries with AI-powered matching',
        'Professional networking with peer directors and industry leaders',
        'Committee role recommendations based on functional expertise',
      ],
    },
    {
      title: '3. Professional Development',
      items: [
        'Continuing education credit courses and regulatory update workshops',
        'Industry-specific governance training with external expert trainers',
        'Current topics including ESG, cybersecurity, and digital transformation',
      ],
    },
    {
      title: '4. Peer Exchange Programs',
      items: [
        'Monthly director roundtables and industry-specific peer groups',
        'Anonymous consultation services for sensitive board matters',
        'Cross-industry best practice sharing and collaborative learning',
      ],
    },
    {
      title: '5. Legal & Advisory Support',
      items: [
        'Expert advisory for contentious and sensitive board issues',
        'Crisis management and stakeholder communication guidance',
        'Professional liability and D&O insurance advisory services',
      ],
    },
    {
      title: '6. Secretarial Support',
      items: [
        'Comprehensive position tracking across multiple boards',
        'Annual declaration and certification preparation',
        'Automatic filing updates and compliance calendar management',
      ],
    },
    {
      title: '7. Legal Monitoring',
      items: [
        'Proactive legal proceeding searches and early warning systems',
        'Regulatory authority communication tracking',
        'Issue resolution support and legal counsel coordination',
      ],
    },
    {
      title: '8. Executive Services',
      items: [
        'Complete travel and accommodation management for board meetings',
        'Multi-board calendar synchronization and conflict resolution',
        'Meeting preparation support with briefing and research assistance',
      ],
    },
    {
      title: '9. Compensation Advisory',
      items: [
        'Market intelligence reports with peer comparison data',
        'Negotiation support and market positioning guidance',
        'Give-to-get information sharing for enhanced benchmarking',
      ],
    },
    {
      title: '10. Capital Markets Support',
      items: [
        'DRHP documentation and independence certification assistance',
        'M&A transaction oversight and governance guidance',
        'Investor relations and stakeholder communication advisory',
      ],
    },
  ];

  return (
  <div className="w-full">
    {/* ================== SECTION 1 : THEME BACKGROUND ================== */}
    <section className="relative w-full min-h-[10px]">
      <div
        className="absolute inset-0 -z-10 bg-gradient-to-b from-theme-purple to-white"
        style={{
          clipPath: 'polygon(0 0, 100% 20%, 100% 100%, 0 100%)', // keep slant but extend slightly
        }}
      />
      <div className="container mx-auto max-w-6xl px-6 pt-20 pb-16"> {/* added bottom padding */}
        <Fade bottom triggerOnce />
      </div>
    </section>

    {/* ================== SECTION 2 : WHITE BACKGROUND ================== */}
    <section className="relative bg-white -mt-12 z-10 rounded-t-3xl shadow-xl">
      {/* 
        -mt-12 pulls the white section upward to overlap the gradient
        rounded-t-3xl + shadow-xl makes it look like a card emerging from the slant
      */}
      <div className="container mx-auto max-w-6xl px-6">
        <Fade bottom triggerOnce delay={400}>
          <div className="mb-16 pb-10">
            <div className="space-y-10">
              {independentDirectorSections.map((section, idx) => (
                <Fade bottom triggerOnce delay={idx * 100} key={idx}>
                  <div className="flex flex-col md:flex-row md:items-start md:space-x-10">
                    <div className="md:w-1/3">
                      <h4 className="text-xl font-semibold text-gray-800">
                        {section.title}
                      </h4>
                    </div>
                    <div className="md:w-2/3 text-gray-600 leading-relaxed">
                      <p>{section.items.join(' • ')}</p>
                    </div>
                  </div>

                  {idx !== independentDirectorSections.length - 1 && (
                    <div className="border-b-4 border-black mt-6" />
                  )}
                </Fade>
              ))}
            </div>
          </div>
        </Fade>
      </div>
    </section>

      {/* ================== SECTION 3 : THEME BACKGROUND ================== */}
      <section className="relative w-full">
      {/* Purple gradient background with slant */}
      <div
        className="absolute inset-0 -z-10 bg-gradient-to-b from-theme-purple to-white"
        style={{
          clipPath: 'polygon(0 0, 100% 8%, 100% 100%, 0 100%)',
        }}
      />
      
      <div className="container mx-auto px-6 pt-28 pb-20">
                  <h2 className="text-3xl font-bold text-white text-center mb-16">
                    Unique Value Proposition
                  </h2>
                  {/* Flow container */}
                  <div className="flex flex-wrap justify-center items-center gap-12 relative">
                    {[
                      { title: "End-to-end lifecycle support", icon: FiUserCheck },
                      { title: "Technology-enabled efficiency", icon: FiTrendingUp },
                      { title: "Regulatory expertise integration", icon: FiUsers },
                      { title: "Professional community building", icon: FiFileText },
                      { title: "Transparent benchmarking", icon: FiBarChart2 },
                    ].map((service, idx, arr) => {
                      const Icon = service.icon;
                      return (
                        <div key={idx} className="relative flex flex-col items-center">
                          <motion.div
                            initial={{ scale: 0.8, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            transition={{ delay: idx * 0.2 }}
                            className="w-40 h-40 rounded-full bg-white border-2 border-theme-blue shadow-lg flex flex-col items-center justify-center text-center px-4"
                          >
                            <div className="w-14 h-14 rounded-full bg-theme-blue flex items-center justify-center text-white mb-3">
                              <Icon size={28} />
                            </div>
                            <h5 className="text-sm font-semibold text-gray-800">
                              {service.title}
                            </h5>
                          </motion.div>
      
                          {/* Arrow except last circle */}
                          {idx < arr.length - 1 && (
                            <div className="hidden md:flex items-center absolute right-[-4.5rem] top-1/2 -translate-y-1/2">
                              <div className="w-12 h-[2px] bg-white/70" />
                              <div className="w-0 h-0 border-t-[6px] border-b-[6px] border-l-[10px] border-t-transparent border-b-transparent border-l-white ml-1" />
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
      
    </section>

    </div>
  );
}
